import React from 'react';
import BreadCrumbSelector from '../../components/BreadCrumb/BreadCrumbSelector';
import ServiceRequest from './ServiceRequest';

function ServiceRequestPage() {
    return (
        <>
            <BreadCrumbSelector additionalCrumbs={[{ label: 'Service Anfrage' }]} />
            <ServiceRequest />
        </>
    );
}

export default ServiceRequestPage;
